module.exports = __webpack_public_path__ + "img/TraumI.ce8bb3fc.jpg";